import type { Presentation, ListItem } from '../../types';
import { DeepLinkCta } from './DeepLinkCta';

interface Props {
  p: Extract<Presentation, { type: 'list' }>;
}

export function ListPresentation({ p }: Props) {
  return (
    <div className="presentation-card">
      {p.title && <div className="presentation-title">📋 {p.title}</div>}
      <ul className="presentation-list">
        {p.items.map((item, i) => (
          <li key={i}>
            <span className="list-icon">{iconChar(item.icon)}</span>
            <span className="list-label">{item.label}:</span>{' '}
            <span className="list-value">{item.value}</span>
          </li>
        ))}
      </ul>
      {p.cta && <DeepLinkCta cta={p.cta} />}
    </div>
  );
}

function iconChar(icon: ListItem['icon']): string {
  if (icon === 'check') return '✓';
  if (icon === 'x') return '✗';
  return 'ℹ';
}
